import api from './../api/index'
// 获取参数
function getQueryVariable(variable)
{
       var query = window.location.search.substring(1);
       var vars = query.split("&");
       for (var i=0;i<vars.length;i++) {
               var pair = vars[i].split("=");
               if(pair[0] == variable){return pair[1];}
       }
       return(false);
}

function getCookie(name) {
    let aa = document.cookie.split(';')
    let bb = null;
    aa.forEach(val => {
        if (val.indexOf(name) !== -1) {
            bb = val.split('=');
        }
    })
    localStorage.setItem(name, bb && bb[1])
    return bb && bb[1];
}

const getUserAgent = (getWechat = true) =>{
    const ua = window.navigator.userAgent.toLowerCase();
    if(getWechat && ua.indexOf('micromessenger') !== -1) {
        return 'wechat'
    } else if(ua.match(/isapp/i) == "isapp") {
        if(ua.indexOf('android') > -1 || ua.indexOf('adr') > -1) {
            return 'android'
        } else if(/(ios|ipad|iphone)/.test(ua)) {
            return 'ios'
        }
        return 'h5'
    }
    return 'h5'
};
// 获取入驻机构域名
async function getSaasBranchDomain(branchId){
    let h5domain = ''
    await api.entityGoodsDetail.getSaasBranchDomain(branchId).then((res) => {
        if (res.success && res.data && res.data.length) {
            res.data.forEach((item) => {
                if(item.branchDomain){
                    if(item.branchDomain.includes('h5')){
                        h5domain = item.branchDomain
                    }
                }
            })
            if (h5domain) {
                let protocol = 'https://'
                // if (h5domain.includes('testing3')) {
                //     protocol = 'http://'
                // }
                h5domain = protocol + h5domain
            }
        }
    })
    return h5domain
}

//判断是浏览器环境还是app环境
function getAppEnvironment(name) {
    var ua = navigator.userAgent.toLowerCase();
    console.log("ua",ua)
    if (ua.match(/isapp/i) == "isapp") {
      return true;
    }
    return false;
}


function optimizationImage(path, config = {}) {
  if(path.indexOf('aliyuncs') == -1) {
      return path
  }
  // 格式 size = 0 不进行缩放
  let {format = 'jpg', size = {
      w: 166,
      h: 166,
  }, resize ={
      m: 'pad',
  },webp = true} = config;
  const useWebp = document
          .createElement('canvas')
          .toDataURL('image/webp')
          .indexOf('data:image/webp') === 0;
  const imgFormat = `format,${!webp ? format:  useWebp ? 'webp' : format}`;

  // 尺寸
  let imgResize = ''
  const sizeText = Object.keys(size)
      .map(
          key => `${key}_${size[key]}`,
      )
      .join(',');

  const resizeText = Object.keys(resize)
      .map(key => `${key}_${resize[key]}`)
      .join(',');
  if ((resizeText || sizeText) && size !=0) {
      imgResize = `/resize,${resizeText && sizeText ? `${resizeText},` : ''}${sizeText}`;
  }

  return `${path}?x-oss-process=image/${imgFormat}${imgResize}`
}

const mobileDateFormat = (value) => (value ? value.replace(/-/g, '/') : '');
export default {
    getQueryVariable,
    getUserAgent,
    getCookie,
    getSaasBranchDomain,
    mobileDateFormat,
    getAppEnvironment,
    optimizationImage
}